module.exports = __webpack_public_path__ + "img/a-lingwei-nan.f40ba9e4.jpg";